class GeoJSON {
    constructor(map) {
        this.map = map;
    }

    // Fetch locations and return GeoJSON
    parseDataFromLocations(locations, activeLocationId) {
        let filteredLocations = locations;

        if(activeLocationId !== undefined) {
            filteredLocations = locations.filter(loc => loc.id === activeLocationId);
        }

        return {
            type: 'FeatureCollection',
            features: filteredLocations.map(loc => ({
                type: 'Feature',
                properties: {
                    id: loc.id,
                    title: loc.title,
                    thumbnail: loc.thumbnail,
                    address: loc.address,
                    services: loc.services
                },
                geometry: {
                    type: 'Point',
                    coordinates: [loc.latlng[1], loc.latlng[0]]
                }
            }))
        };
    }
}

export default GeoJSON;
